import { render, staticRenderFns } from "./NodeSummary.vue?vue&type=template&id=72f48b4b&scoped=true&"
import script from "./NodeSummary.vue?vue&type=script&lang=js&"
export * from "./NodeSummary.vue?vue&type=script&lang=js&"
import style0 from "./NodeSummary.vue?vue&type=style&index=0&id=72f48b4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f48b4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow,VTooltip})
